<template>
  <v-layout v-if="!$apollo.loading">
    <v-flex>
      <preview
        :background-image-url="backgroundImageURL"
        :items="items"
        :height="height"
        :width="width"
        :accreditation="accreditation"
        :attendee-fields="attendeeFields"
        @on-ready="onPreviewReady"
      />
      <preview
        v-if="hasBackSide"
        class="back-side"
        :background-image-url="backBackgroundImageURL"
        :items="backItems"
        :height="height"
        :width="width"
        :accreditation="accreditation"
        :attendee-fields="attendeeFields"
        @on-ready="onPreviewReady"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { CREATE_PRINT } from '../../graphql/print.graphql'
import { GET_PRINT_DATA } from './../../graphql/event.graphql'
import Preview from './preview.vue'
import { objectToArray, isSafari } from './../../utils'
import { formats, mmToPixel } from './builder.utils'

export default {
  components: {
    Preview,
  },
  props: {
    accreditationUuid: String,
    eventId: String,
  },
  data() {
    return {
      event: {},
      height: -1,
      width: -1,
      backgroundImageURL: null,
      items: [],
      backBackgroundImageURL: null,
      backItems: [],
      hasBackSide: false,
      previewsReady: 0,
      accreditation: null,
    }
  },
  async created() {
    const results = await this.$apollo.mutate({
      mutation: CREATE_PRINT,
      variables: {
        accreditationUUID: this.accreditationUuid,
      },
    })
    const hasPermission = !!results.data.createPrint
    if (!hasPermission) {
      this.goTo(this.routes.organizer.accreditations)
    }
  },
  beforeMount() {
    window.onafterprint = () => {
      window.close()
    }
  },
  destroyed() {
    window.onafterprint = null
  },
  methods: {
    async openPrint() {
      setTimeout(() => {
        window.print()
      }, 1)
    },
    onPreviewReady() {
      this.previewsReady += 1
      const expectedPreviews = this.hasBackSide ? 2 : 1
      if (this.previewsReady === expectedPreviews) this.openPrint()
    },
  },
  apollo: {
    getEvent: {
      query: GET_PRINT_DATA,
      variables() {
        return {
          id: this.eventId,
          attendeeUUID: this.accreditationUuid,
        }
      },
      async result({ data, loading }) {
        if (!loading) {
          const { getEvent: event, getAttendee: attendee } = data
          if (event.builder) {
            const {
              orientation,
              backgroundImage,
              items,
              backBackgroundImage,
              backItems,
              hasBackSide,
            } = event.builder
            this.backgroundImageURL = backgroundImage
            this.items = items || []
            this.backBackgroundImageURL = backBackgroundImage
            this.backItems = backItems || []
            this.hasBackSide = Boolean(hasBackSide)
            const format = formats.find(f => event.builder.format === f.name)
            const { width, height, defaultOrientation } = format
            const orientationChanged = orientation !== defaultOrientation
            this.width = mmToPixel(!orientationChanged ? width : height)
            this.height = mmToPixel(!orientationChanged ? height : width)
            this.accreditation = attendee
          } else {
            this.goBack()
          }
          this.attendeeFields = objectToArray(event.attendeeFields, 'name')
        }
      },
    },
  },
}
</script>

<style scoped>
.back-side {
  page-break-before: always;
}
</style>
